<template>
	<div class="rightInner">
		<div class="searchArea">
			<div class="title">
				<div class="titleLine"></div>
				{{$t('mypages.order.title')}}
			</div>
			<div>
				<ul class="tabsArea">
					<li :class="{active: tabIndex == 0}" @click="tabClick(0)">{{$t('mypages.order.tab_all')}}</li>
					<li :class="{active: tabIndex == 1}" @click="tabClick(1)">{{$t('mypages.order.tab_pending_payment')}}</li>
					<li :class="{active: tabIndex == 2}" @click="tabClick(2)">{{$t('mypages.order.tab_pending_ship')}}</li>
					<li :class="{active: tabIndex == 3}" @click="tabClick(3)">{{$t('mypages.order.tab_pending_receive')}}</li>
					<li :class="{active: tabIndex == 4}" @click="tabClick(4)">{{$t('mypages.order.tab_completed')}}</li>
				</ul>
				<div class="conditions">
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.order.label_platform_order_no')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.order.placeholder_platform_order_no')" v-model="form.orderNo" />
					</div>
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.order.label_product_name')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.order.placeholder_product_name')" v-model="form.productName"/>
					</div>
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.order.label_purchase_order_no')}}</div>
						<input type="text" class="small" :placeholder="$t('mypages.order.placeholder_purchase_order_no')" v-model="form.saleNo"/>
					</div>					
				</div>
				<div  class="conditions setPadding">
					<div class="condition">
						<div class="conditionLabel">{{$t('mypages.order.label_order_time')}}</div>
						<div class="calendarArea">
							<div class="calendarInner" @click="strarShow()">
								<input type="text" id="startTime"   v-model="form.startTime"/>
								<img  src="../../assets/images/dateIcon.png"/>
							</div>
							<div class="calendatPopup" v-if="isStart">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>						
						</div>
						<div class="calendarLine">~</div>
						<div class="calendarArea">
							<div class="calendarInner"  @click="endShow()">
								<input type="text"   id="endTime"   v-model="form.endTime"/>
								<img  src="../../assets/images/dateIcon.png"/>
							</div>							
							<div class="calendatPopup" v-if="isEnd">
								<CalendarVue @changeDate="getDate" :initDay="calendarInitDay"></CalendarVue>
							</div>							
						</div>
						<div class="searchBtn btnStyle" @click="Search()" >{{$t('mypages.order.search')}}</div>
						<div class="resetBen btnStyle" @click="Reset()">{{$t('mypages.order.reset')}}</div>
					</div>
				</div>
			</div>
			
		</div>
		<div>
                <div class="orderHead">
                	<div class="orderTitle">{{$t('mypages.order.header_order_info')}}</div>
                	<div class="orderType">{{$t('mypages.order.header_spec')}}</div>
                	<div class="orderNum">{{$t('mypages.order.header_quantity')}}</div>
                	<div class="orderAmount">{{$t('mypages.order.header_total_amount')}}</div>
                	<div class="orderStatus">{{$t('mypages.order.header_status')}}</div>
                	<div class="orderTool">{{$t('mypages.order.header_action')}}</div>
                </div>
			<div class="orderBody"  v-for="(item,index) in orderList" :key="item.id">
				<div class="orderInfoTitle">
					<div>{{$t('mypages.order.platform_order_no')}}{{item.order_no}}<span>|</span>{{$t('mypages.order.purchase_order_no')}}{{item.sale_no}}<span>|</span>{{$t('mypages.order.order_time')}}{{item.gmt_order}}</div>
					<div>{{$t('mypages.order.recipient')}}{{item.receive_name}}<span>|</span>{{$t('mypages.order.invoice_title')}}南通商策信息科技有限公司  </div>
				</div>
				<table class="orderLists">
					<tr >
						<td>
							<div class="orderlist" v-for="(detail,index) in item.detail_list" :key="detail.detail_id">
								<div class="orderTitle titleFlex">
								<img  :src="detail.sku_image"/>
								<div class="infoDetail ">
									<div class="infoText">{{detail.product_name}}</div>
									<div class="grayText">{{detail.cate_name}}</div>
									<div class="price">￥{{detail.sale_price}}</div>
								</div>
								</div>
								<div class="infolist orderType">
									{{detail.sku_text}}
								</div>
								<div class="orderNum textCenter">{{detail.number}}</div>
							</div>
						</td>
						<td rowspan="2">
							<div class="orderAmount amountTd">
								<div class="redPrice">￥{{item.product_amount}}</div>
								<div class="grayText">(含税费:￥{{item.order_amount}})</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==0">
							<div class="orderStatus amountTd">
								<div class="statusText">{{$t('mypages.order.status_pending_payment')}}</div>
								<div class="moreText" @click="detailClick(item.id)">{{$t('mypages.order.view_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==0">
							<div class="orderToolTd amountTd" v-if="!isBeforeCurrentDate(item.endtime)">
								<div class="payBtn"  @click="submitOrder(item.id)">{{$t('mypages.order.pay_now')}}</div>
								<div class="cancelText" @click="cancelOrder(item.id)">{{$t('mypages.order.cancel_order')}}</div>
							</div>
							<div class="orderToolTd amountTd" v-else>
								<!-- <div class="payBtn"  @onclick="submitOrder(item.id)">立即支付</div> -->
								<div class="cancelText" @click="cancelOrder(item.id)">取消订单</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==1">
							<div class="orderStatus amountTd">
								<div class="statusText">{{$t('mypages.order.status_pending_ship')}}</div>
								<div class="moreText" @click="detailClick(item.id)">{{$t('mypages.order.view_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==1">
							<div class="orderToolTd amountTd">							
								<!-- <div class="payBtn">立即催单</div> -->
								<div class="cancelText" @click="addCart(item.id)">{{$t('mypages.order.add_to_cart')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==2">
							<div class="orderStatus amountTd">
								<div class="statusText">{{$t('mypages.order.status_pending_receive')}}</div>
								<div class="moreText" @click="detailClick(item.id)">{{$t('mypages.order.view_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==2">
							<div class="orderToolTd amountTd">							
								<div class="payBtn" @click="receiveOrder(item.id)">{{$t('mypages.order.confirm_receive')}}</div>
								<div class="cancelText">{{$t('mypages.order.add_to_cart')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==3">
							<div class="orderStatus amountTd">
								<div class="statusText">{{$t('mypages.order.status_received')}}</div>
								<div class="moreText" @click="detailClick(item.id)">{{$t('mypages.order.view_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==3">
							<div class="orderToolTd amountTd">							
								<!-- <div class="payBtn">立即催单</div> -->
								<div class="cancelText" @click="addCart(item.id)">{{$t('mypages.order.add_to_cart')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==-1">
							<div class="orderStatus amountTd">
								<div class="statusText">{{$t('mypages.order.status_cancelled')}}</div>
								<div class="moreText" @click="detailClick(item.id)">{{$t('mypages.order.view_detail')}}</div>
							</div>
						</td>
						<td rowspan="2" v-if="item.order_state==-1">
							<div class="orderToolTd amountTd">							
								<!-- <div class="payBtn">立即催单</div> -->
								<div class="cancelText" @click="addCart(item.id)">加入购物车</div>
							</div>
						</td>
					</tr>				
				</table>
			</div>
		
			<div class="paginationArea">
				<PaginationVue  :TotalCount="totalcount" :pageSize="10" @pageChenged="handlePage"></PaginationVue>
			</div>
		</div>
	</div>
</template>

<script>
	import CalendarVue from "../../components/calendar.vue"
    import PaginationVue from '../../components/pagination.vue';
	export default{
		components:{
			CalendarVue,
			PaginationVue
		},
		data(){
			return {
				calendarInitDay: '2024-12-1',
				tabIndex:0,
				isStart: false,
				isEnd:false,
				allItems:['1','2','3','4','5','6','7','8','9','10','11','12','13','14'],
				orderList:[],
				totalcount:1,
				pageIndex:1,
				form: {
					orderNo: '',
					productName: '',
					saleNo:'',
					startTime: '',
					endTime: '',
					status:''
				},
			}
		},
		created(){
			this.tabIndex=this.$route.query.state;
			if(this.tabIndex==0)
			{
				this.form.status='';
			}
			if(this.tabIndex==1)
			{
				this.form.status=0;
			}
			if(this.tabIndex==2)
			{
				this.form.status=1;
			}
			if(this.tabIndex==3)
			{
				this.form.status=2;
			}
			if(this.tabIndex==4)
			{
				this.form.status=3;
			}
			this.getOrderListInfo();
		},
		mounted(){
			 document.addEventListener('click', this.hideCalendar)
		},		
		methods:{
			tabClick(idx){
				this.tabIndex = idx;
				if(idx==0)
				{
					this.form.status='';
				}
				if(idx==1)
				{
					this.form.status=0;
				}
				if(idx==2)
				{
					this.form.status=1;
				}
				if(idx==3)
				{
					this.form.status=2;
				}
				if(idx==4)
				{
					this.form.status=3;
				}
				this.getOrderListInfo();
			},
			handlePage(message) {
				//console.log(message);
				this.pageIndex = message;
				this.getOrderListInfo();
			},
			getDate(d){
				console.log(d)
				if(this.isStart){
					this.isStart = !this.isStart;
					this.form.startTime=d;
					return;
				}
				if(this.isEnd){
					this.isEnd = !this.isEnd;
					this.form.endTime=d;
					return;
				}
			},
			strarShow(){
				this.isStart = true;
				this.isEnd = false;
			},
			endShow(){
				this.isEnd = true;
				this.isStart = false
			},
			hideCalendar(event){
			    if (!event.target.closest('.calendarArea')) {
					this.isStart = false;
					this.isEnd = false;
				}
			},
			detailClick(id){
				this.$emit('detailClick',id);
			},
			getOrderListInfo() {
				this.orderList=[];
				this.$scUtil.axiosPut(this, 'OrderApi/GetOrderPageList', {
					orderNo: this.form.orderNo,
					saleNo:this.form.saleNo,
					productName:this.form.productName,
					startTime:this.form.startTime,
					endTime:this.form.endTime,
					userName: localStorage.getItem('username'),
					pageIndex:this.pageIndex,
					pageSize:10,
					status:this.form.status
				}, res => {
					console.log(res.code);
					if (res.code == 100) {
						this.orderList = res.data;
						this.totalcount=res.totalcount;
						//console.log(JSON.stringify(this.orderList))

					}

				});
			},
			Search()
			{
					this.getOrderListInfo();
			},
			Reset(){
				this.form.orderNo='';
				this.form.productName='';
				this.form.saleNo='',
				this.form.startTime='',
				this.form.endTime='',
				this.getOrderListInfo();
			},
			isBeforeCurrentDate(dateInfo) {
			      const currentDate = new Date();
			      const dateToCompare = new Date(dateInfo);
				  //console.log(dateInfo);
			      return currentDate > dateToCompare;
			},
			submitOrder(orderid)
			{
				this.$router.push({ path:'/pay' , query:{id:orderid}});
			},
			cancelOrder(orderid)
			{
				this.$confirm(`确认要取消该订单吗?`, '提示', {
					distinguishCancelAndClose: true,
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					 try 
					 {
						this.$scUtil.axiosPut(this, 'OrderApi/CancelOrder', {
							id: orderid,
						}, res => {
							if (res.code == 100) {
								this.$message({
									message: res.message,
									type: "success"
								});
								this.getOrderListInfo();
								//console.log("为什么删除了不刷新数据");
								//console.log(JSON.stringify(this.shopCartList));
								return;
							}
					 
						});
					 } catch (error) {
						//console.log(error);
					 }
				  }).catch(action => {
					// 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
					//console.log(action)
					if (action == 'cancel' || action == 'close') {
					  this.getOrderListInfo();
					}
				})
			},
			receiveOrder(orderid)
			{
				this.$confirm(`确认要收货吗?`, '提示', {
					distinguishCancelAndClose: true,
					confirmButtonText: '确认',
					cancelButtonText: '取消',
					type: 'warning'
				  }).then(() => {
					 try 
					 {
						this.$scUtil.axiosPut(this, 'OrderApi/ReceiveOrder', {
							id: orderid,
						}, res => {
							if (res.code == 100) {
								this.$message({
									message: res.message,
									type: "success"
								});
								this.getOrderListInfo();
								//console.log("为什么删除了不刷新数据");
								//console.log(JSON.stringify(this.shopCartList));
								return;
							}
					 
						});
					 } catch (error) {
						//console.log(error);
					 }
				  }).catch(action => {
					// 判断是 cancel (自定义的取消) 还是 close （关闭弹窗）
					//console.log(action)
					if (action == 'cancel' || action == 'close') {
					  this.getOrderListInfo();
					}
				})
			},
			addCart(orderid) {
				try {
					this.$scUtil.axiosPut(this, 'ShoppingCartApi/AddByOrder', {
						id: orderid,
						userName: localStorage.getItem('username'),
					}, res => {
						console.log(res.code);
						if (res.code == 100) {
							this.$message({
								message: res.message,
								type: "success"
							});
							return;
						}

					});
				} catch (error) {
					console.log(error);
				}
			}
		}
	}
</script>

<style scoped>
	
	.rightInner{
		width: 958px
	}
	
	.searchArea{
		width: 100%;	
		background-color: #fff;
	}
	
	.title{
		font-size: 14px;
		color: #000000;
		display:flex;
		align-items: center;
		height: 52px;
		border-bottom: 1px solid #e2e2e2;
		padding-left: 20px;
	}
	
	.titleLine{
		width: 4px;
		height: 14px;
		background-color: #0380fe;
		margin-right: 15px;
	}
	
	ul.tabsArea{
		display: flex;
		align-items: center;
		padding-left: 16px;
	}
	
	ul.tabsArea li{
		list-style: none;
		margin-right: 60px;
		height: 35px;
		display: flex;
		align-items: flex-end;
		font-size: 14px;
		color: #666666
	}
	
	ul.tabsArea li.active{
		color: #0380fe;
		border-bottom: 2px solid #0380fe;
	} 
	
	.conditions,.condition{
		display: flex;
		align-items: center;
	}
	
	.conditions{
		margin-top: 20px;
		padding-left: 20px;
	}
	
	.conditionLabel{
		font-size: 13px;
		color: #000000;
		margin-right: 10px;
		width: 80px;
		text-align: right;
	}
	
	.small{
		width: 158px;
		height: 32px;
	}
	
	.condition input{
		border: 1px solid #e2e2e2;
		font-size: 13px;
		color: #000;
		padding-left: 10px;
	}
	
	.condition input:focus{
		outline: none;
	}
	
	.condition input::placeholder{
		color: #888;
	}
	
	.condition{
		margin-right: 40px;
	}
	
	.condition:nth-last-child(1){
		margin-right: 0px;
	}
	
	.calendarArea{
		position: relative;
		display: flex;
		align-items: center;
	}	
	
	.calendarArea input{
		height: 170px;
		height: 32px;
		border: none;
	}
	
	.calendarInner{
		width: 200px;
		height: 32px;
		border: 1px solid #e2e2e2;
	}
	
	.calendatPopup{
		position: absolute;
		width: 260px;
		top: 34px;
		left: 0;
		background-color: #fff;
		box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.14), 0 3px 1px -2px rgba(0, 0, 0, 0.1),
		0 1px 5px 0 rgba(0, 0, 0, 0.12);
	}
	
	.calendarLine{
		margin: 0 15px;
	}
	
	.setPadding{
		padding-bottom: 20px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.searchBtn{		
		color: #ffffff;
		background-color: #0380fe;
		border: 1px solid #0380fe;	
		margin-left: 36px;
	}
	
	.resetBen{
		color: #ffffff;
		border: 1px solid #e2e2e2;
		color: #666666;
		margin-left: 17px;
	}
	
	.btnStyle{
		width:105px;
		height: 32px;
		font-size: 13px;
		border-radius: 5px;
		text-align: center;
		line-height: 32px;
		cursor: pointer;
	}
	
	.orderHead{
		color: #333333;
		font-size:13px;
		text-align: center;
		display: flex;
		align-items: center;
		height: 50px;
		background-color: #fff;
		padding-left: 20px;
		box-sizing: border-box;
	}
	
	.orderTitle{
		width: 290px;		
	}
	
	.orderType{
		width: 204px;
	}
	
	.orderNum{
		width: 80px;
	}
	
	.orderAmount{
		width: 137px;
	}
	
	.orderStatus{
		width: 98px;
	}
	
	.orderTool{
		width: 149px;
	}
	
	.orderBody{
		margin-top: 20px;
		background-color: #fff;
	}
	
	.orderInfoTitle{
		font-size: 12px;
		color: #333333;
		height: 65px;
		display:flex;
		flex-direction: column;
		align-items: flex-start;
		justify-content: center;
		padding-left: 21px;
		line-height: 20px;
		border-bottom: 1px solid #e2e2e2;
	}
	
	.orderInfoTitle span{
		margin:0 24px;
	}
	
	
	.orderlist{
		display: flex;
		align-items: center;		
		padding: 20px 0 20px 0;
		box-sizing: border-box;
		border-bottom: 1px solid #e7e7e7;
	}
	
	.orderlist:nth-last-child(1){
		border-bottom: none;
	}
	
	.infoDetail{
		word-break: break-all;	
	}
	
	.orderlist img{
		width: 79px;
		height: 79px;
		border: 1px solid #e7e7e7;
		margin-right: 15px;
	}
	
	.infoText{
		font-size: 13px;
		color: #000000;
	}
	
	.grayText{
		font-size: 12px;
		color: #888888;
	}
	
	.infolist{
		font-size: 12px;
		color: #333333;
		line-height: 20px;
	}
	
	.price{
		color: #db050f;
		font-size: 14px;
		font-weight: bolder;
	}
	
	.infolist p{
		width: 100%;
		text-align: left;
	}
	
	.titleFlex{
		display: flex;
		padding-right:30px;
		box-sizing: border-box;
		padding-left: 20px;
	}
	
	.textCenter{
		text-align: center;
	}
	
	.amountTd{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
	}
	
	.redPrice{
		font-size: 14px;
		color: #db050f;
	}
	
	table{
		border-collapse: collapse;
	}
	
	table tr td{
		border: 1px solid #e7e7e7;
		border-top: none;
	}
	
	.statusText{
		font-size: 13px;
		color: #333333;
	}
	
	.moreText{
		font-size: 13px;
		color: #0380fe;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.orderToolTd{
		width: 144px;
	}
	
	.timeText{
		font-size: 13px;
		color: #333333;
	}
	
	.timeText span{
		font-size: 14px;
		color: #0380fe;
		font-weight: bolder;
	}
	
	.payBtn{
		width: 77px;
		height: 24px;
		border: 1px solid #0380fe;
		color: #0380fe;
		font-size: 12px;
		text-align: center;
		line-height: 24px;
		margin-top: 5px;
		cursor: pointer;
	}
	
	.cancelText{
		font-size: 12px;
		color: #333333;
		margin-top: 5px;
		cursor: pointer;
	}
	
	table tr td:nth-child(1){
		border-left: 0px solid transparent;
	}
	
	table tr td:nth-last-child(1){
		border-right: 0px solid transparent;
	}
	
	.paginationArea{
		width: 100%;
		display: flex;
		justify-content: center;
		padding: 30px 0;
	}
</style>